import { tokenService } from '../../../common'
import { AnalyticsEvent } from '../../../service/analytics-events'
import { analyticsService } from '../../../service/analytics-service'
import { errorUtil } from '../../../util/auth-error-util'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../../../util/auth-event-bus-util'
import { LoadingSpinner } from '../util/spinner/loading-spinner'
import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

export const LogoutRedirect = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    setIsLoading(true)
    // Reported while still identified, then a new anonymous analytics identity — or the next
    // account on this browser inherits this one.
    analyticsService.track(AnalyticsEvent.LOGGED_OUT)
    analyticsService.reset()
    tokenService
      .clear()
      .then(() => {
        eventBusUtil().emit({
          action: EventBusActionType.REMOVE,
          entity: EventBusEntityType.ACCESS_TOKEN,
          meta: {}, // TODO check if this is needed on web-app
        })
        setIsLoading(false)
      })
      .catch((err: Error) => {
        errorUtil.logError(err)
        setIsLoading(false)
      })
  }, [])
  return (
    <LoadingSpinner isLoading={isLoading}>
      <Navigate to="/auth/get-in" replace />
    </LoadingSpinner>
  )
}
